export const setHtmlPageLang = (locale: LocaleType | string) => {
  document.querySelector('html')?.setAttribute('lang', locale)
}
